import { Button } from '@ps/isp-web-component-library';
import type { MeetingBasedEventTypeId } from '@ps/isp-web-services-types';
import type { TranslationTag } from '@ps/web-core-intl';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import { select } from '@swf/core/store';
import { Icon, SportsLink } from '@swf/sports/components';
import { EventTypeId } from '@swf/sports/types/eventType';
import { isMeetingBasedEventTypeId } from '@swf/sports/utils/isEventTypeId';

import {
  TXTWCL_Antepost_betting_for_this_meet_ELL,
  TXTWCL_Go_To_Greyhound_Racing,
  TXTWCL_Go_To_Horse_Racing
} from './AntePostEndedMessage.messages.json';
import styles from './AntePostEndedMessage.scss';

const translationMap: Record<MeetingBasedEventTypeId, TranslationTag> = {
  [EventTypeId.HORSE_RACING]: TXTWCL_Go_To_Horse_Racing,
  [EventTypeId.GREYHOUND_RACING]: TXTWCL_Go_To_Greyhound_Racing
};

const AntePostEndedMessage: React.FC = () => {
  const { eventTypeSlug, eventTypeId } = useSelector(select.sports.getUrlParams);
  const { formatMessage } = useRegulatoryIntl();
  const parsedEventTypeId = Number(eventTypeId);

  if (!isMeetingBasedEventTypeId(parsedEventTypeId)) return null;

  return (
    <div className={styles.container}>
      <Icon
        name="finishingpost"
        label={formatMessage(TXTWCL_Antepost_betting_for_this_meet_ELL)}
        size="x4"
        className={styles.finishingPost}
      />
      <span className={styles.finishedText}>
        <Translation {...TXTWCL_Antepost_betting_for_this_meet_ELL} />
      </span>
      <Button
        as={SportsLink}
        values={{ eventTypeSlug, eventTypeId }}
        alias="sportsAnimalRacingNext"
      >
        <Translation {...translationMap[parsedEventTypeId]} />
      </Button>
    </div>
  );
};

export default AntePostEndedMessage;
